export default __webpack_public_path__ + "static/media/930.6eb9f52a.png";